<mat-expansion-panel [expanded]="accordeonExpanded">
  <mat-expansion-panel-header>
    <mat-panel-title>Manage sections</mat-panel-title>
  </mat-expansion-panel-header>
  @for (sectionForm of toggleSectionsForForm; track sectionForm) {
    <div
      class="form-type-container"
      >
      <p class="form-type-title">{{ sectionForm.formName }}</p>
      <div class="sections-container">
        @for (section of sectionForm.toggleSections; track section) {
          <div
            class="toggle-selector"
            >
            <mat-slide-toggle
              [checked]="section.selected"
              (toggleChange)="onToggleChanged(sectionForm.formId, section.id)"
              >
              {{ section.name }}
            </mat-slide-toggle>
          </div>
        }
      </div>
    </div>
  }
</mat-expansion-panel>
